import React from "react";
import classNames from "classnames";
import BaseRow from "../BaseRow";
import { Tooltip, TooltipBody } from "ComponentsUI/Tooltip";

export default class CostRow extends BaseRow {
	generateCostOfTarifs() {
		let classes = this.props.classes;
		let texts = this.props.text;
		return this.props.data.map((item, index) => {
			let data = item;
			let valuePrice = {
				price:
					typeof data.displayPrice === "number" ? data.displayPrice.toString() : data.displayPrice,
			};

			let priceMeasure = null;
			if (data.price.license_fee_interval.code === "month") {
				priceMeasure = texts.SUBSCRIPTION_FEE_TITLE;
			}
			if (data.price.license_fee_interval.code === "day") {
				priceMeasure = texts.PRICE_IN_DAY;
			}

			let priceComponent = null;

			if (valuePrice.sale) {
				let textTimeGracePeriod = "";

				if (!data?.after?.rule.month_cnt || data?.after?.rule.month_cnt === 0) {
					textTimeGracePeriod = `до ${moment(data?.after.rule.date_end).format("D MMMM YYYY")}`;
				} else {
					textTimeGracePeriod = `${data?.after.rule.month_cnt} ${texts.SERVICES_MONTH}`;
				}

				let salePeriodText = (
					<div>
						<div>{`${texts.ORDER_FORM_GRACE_PERIOD_TITLE}:`}</div>
						<div>{`${textTimeGracePeriod}`}</div>
					</div>
				);

				let saleCostText = (
					<div>
						<div>{`${texts.ORDER_FORM_FEE_PREF}:`}</div>
						<div>{`${valuePrice.sale} ${priceMeasure}`}</div>
					</div>
				);
				priceComponent = (
					<Tooltip
						body={
							<TooltipBody>
								{salePeriodText}
								{saleCostText}
							</TooltipBody>
						}
					>
						<div className={classNames(classes.cellText, classes.withPointer)}>
							<span className={classes.cellTextValue}>{valuePrice.price}</span>
							<span className={classes.asterisk}> * </span>
							<span className={classes.cellTextDimension}>{priceMeasure}</span>
						</div>
					</Tooltip>
				);
			} else {
				priceComponent = (
					<div className={classes.cellText}>
						<span className={classes.cellTextValue}>{valuePrice.price}</span>
						<span className={classes.cellTextDimension}>{priceMeasure}</span>
					</div>
				);
			}

			return (
				<div key={index} className={classes.cell}>
					{priceComponent}
				</div>
			);
		});
	}

	render() {
		let classes = this.props.classes;
		let columns = {
			2: [classes.rowColNumber2],
			3: [classes.rowColNumber3],
			4: [classes.rowColNumber4],
			5: [classes.rowColNumber5],
			6: [classes.rowColNumber6],
		};
		let style = {
			transform: `translateX(${this.props.moveValue}px)`,
		};

		return (
			<div className={classNames(classes.row, columns[this.props.columns])}>
				<div className={classes.headerCell} style={style}>
					<div className={classes.headerCellText}>{this.props.header}</div>
				</div>
				<div className={classes.cellsWrapper}>{this.generateCostOfTarifs()}</div>
			</div>
		);
	}
}
